import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b2721d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, null, -1))
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "pages" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Privacy Policy")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Terms of Use")
const _hoisted_6 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Brands = _resolveComponent("Brands")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Brands)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: _ctx.privacyPolicyLink }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: _ctx.termsOfUseLink }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, " Copyright © 2023 " + _toDisplayString(_ctx.$t('navigation.navbar.appTitle')) + ". All Rights Reserved ", 1)
  ]))
}